var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsString, IsOptional, IsEnum, IsDate, IsNumber, IsArray, IsObject } from 'class-validator';
import { Species } from './Species';
import { Gender, GenderDeterminationMethod, BirdStatus } from '../enums';
export class Bird {
    constructor(data) {
        this.id = '';
        this.bandId = '';
        this.gender = Gender.UNKNOWN;
        this.genderDeterminationMethod = GenderDeterminationMethod.NOT_SEXED;
        this.status = BirdStatus.AVAILABLE;
        this.hatchingDate = new Date();
        this.bandingDate = new Date();
        this.cageNumber = '';
        this.provenance = {
            type: 'BRED',
            fatherId: '',
            motherId: '',
            sellerName: '',
            sellerContact: '',
            dateAcquired: new Date(),
            price: 0,
            notes: ''
        };
        Object.assign(this, data);
    }
    get age() {
        const today = new Date();
        const birthDate = this.hatchingDate || this.bandingDate;
        const age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            return age - 1;
        }
        return age;
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], Bird.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], Bird.prototype, "bandId", void 0);
__decorate([
    IsObject(),
    __metadata("design:type", Species)
], Bird.prototype, "species", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Bird.prototype, "mutationName", void 0);
__decorate([
    IsEnum(Gender),
    __metadata("design:type", String)
], Bird.prototype, "gender", void 0);
__decorate([
    IsEnum(GenderDeterminationMethod),
    __metadata("design:type", String)
], Bird.prototype, "genderDeterminationMethod", void 0);
__decorate([
    IsEnum(BirdStatus),
    __metadata("design:type", String)
], Bird.prototype, "status", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], Bird.prototype, "sellPrice", void 0);
__decorate([
    IsDate(),
    __metadata("design:type", Date)
], Bird.prototype, "hatchingDate", void 0);
__decorate([
    IsDate(),
    __metadata("design:type", Date)
], Bird.prototype, "bandingDate", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], Bird.prototype, "cageNumber", void 0);
__decorate([
    IsObject(),
    __metadata("design:type", Object)
], Bird.prototype, "provenance", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Bird.prototype, "phenotype", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], Bird.prototype, "genotype", void 0);
__decorate([
    IsArray(),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], Bird.prototype, "parentIds", void 0);
__decorate([
    IsArray(),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], Bird.prototype, "siblingIds", void 0);
__decorate([
    IsArray(),
    IsString({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], Bird.prototype, "descendantIds", void 0);
__decorate([
    IsArray(),
    IsObject({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], Bird.prototype, "photos", void 0);
__decorate([
    IsArray(),
    IsObject({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], Bird.prototype, "documents", void 0);
__decorate([
    IsArray(),
    IsObject({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], Bird.prototype, "notes", void 0);
__decorate([
    IsArray(),
    IsObject({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], Bird.prototype, "healthTests", void 0);
